
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { CelojumiListing } from './pages/CelojumiListing';
import { PackageDetail } from './pages/PackageDetail';
import { ParMums } from './pages/ParMums';
import { Kontakti } from './pages/Kontakti';
import { BlogListing } from './pages/BlogListing';
import { BlogDetail } from './pages/BlogDetail';
import { ServicesListing } from './pages/ServicesListing';
import { ServiceDetail } from './pages/ServiceDetail';
import { GalamerkiListing } from './pages/GalamerkiListing';
import { CountryDetail } from './pages/CountryDetail';

const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/celojumi" element={<CelojumiListing />} />
          <Route path="/celojums/:slug" element={<PackageDetail />} />
          <Route path="/par-mums" element={<ParMums />} />
          <Route path="/kontakti" element={<Kontakti />} />
          <Route path="/blogs" element={<BlogListing />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/pakalpojumi" element={<ServicesListing />} />
          <Route path="/pakalpojumi/:slug" element={<ServiceDetail />} />
          <Route path="/galamerki" element={<GalamerkiListing />} />
          <Route path="/galamerki/:slug" element={<CountryDetail />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
